// Category pill bar under the hero — removed per request.
// Kept as a no-op so the many pages that render <CategoryNav /> don't need edits.
export default function CategoryNav() {
  return null;
}
